import React, { Component } from "react";
import { Container } from 'react-bootstrap';
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import { withRouter } from "react-router-dom";
import * as Cookies from "es-cookie";
import { isBrowser } from "react-device-detect";
import AssignmentHome from "../components/_assignment/AssignmentHome";

class Assignment extends Component {
    constructor(props) {
        super(props);
        this.state = { toggled: Cookies.get("toggle") };
    }

    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };

    render() {
        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">
                    <div id="sidebar" className={isBrowser ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
                        <SideNavbar />
                    </div>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper mb-2 h-100">
                        <Container fluid className="px-0">
                            <AssignmentHome />
                        </Container>
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}

export default withRouter(Assignment);
